import {Inject, Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { Banner } from '../models/banner-model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HelperService } from './helper.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import {CITY} from "../tokens";

@Injectable({
  providedIn: 'root'
})
export class BannersService {

  constructor(
    private helperService: HelperService,
    private http: HttpClient,
    @Inject(CITY) private injectedCity: string) {
  }

  getHomeBanners(): Observable<any> {
    const city = this.injectedCity || this.helperService.getCity();
    const params = new HttpParams()
      .set("city", city)
      .set("language", "en");

    return this.http.get(environment.BANNERS3_API_URL, { params: params });
  }

  getBannersListingPage(type): Observable<Banner[]> {
    const params = new HttpParams()
      .set("site", this.helperService.getCity())
      .set("type", type)
      .set("lang", "bg")
      .set("i", "3");
//https://zavedenia.com/zavedenia-banners/api/banners2.php?site=sofia&type=26&lang=bg&i=3
    return this.http.get(environment.BANNERS2_API_URL, { params: params })
      .pipe(map(x => this.mapBanners(x)));
  }

  private mapBanners(input: any): Banner[] {
    let banners: Banner[] = [];

    for (const property in input) {
      banners.push({
        idString: property,
        prestiege: property == 'p2' || property == 'p24' || property == 'p54',
        filename: input[property][0].f,
        href: input[property][0].h,
        target: input[property][0].t
      });
    }

    banners.sort((a,b) => {
      const firstB = a.idString;
      const secondB = b.idString;

      if(firstB > secondB)
        return 1;

        return -1;
    })

    return banners;
  }
}
